import React, { useEffect } from 'react'
import './YouMightIntrested.css'
import CommonHeadingBeforeAfterLine from '../../Common-Component/CommonHeadingBeforeAfterLine/CommonHeadingBeforeAfterLine'
import { Swiper, SwiperSlide } from 'swiper/react'
import Shop_by_papers_textures_cards from '../../Common-Component/Shop_by_papers_textures_cards/Shop_by_papers_textures_cards'
import { useDispatch, useSelector } from 'react-redux'
import { getAllProductsNewLaunch } from '../../../features/products/productsSlice'


const YouMightIntrested = ({product}) => {

    const slides = Array(9).fill(null); 
    const dispatch = useDispatch();
    const productdata = useSelector(
        (state) => state.product.allProductsNewLaunch
      );
      useEffect(() => {
        dispatch(
          getAllProductsNewLaunch({
            type: "new-launch",  subcategory_id: product?.sub_category_id,       
          })
        );
      }, [dispatch,product?.sub_category_id]);
    return (
        <section className='YouMightIntrested'>
            <div className='heading_div'>
                <CommonHeadingBeforeAfterLine headingText="You might be interested in" />
            </div>

            <div className='main_swiper_div'>
                <Swiper
                    spaceBetween={30}
                    slidesPerView={4}
                    breakpoints={{
                        0: { slidesPerView: 1.5, spaceBetween: 10 },
                        420: { slidesPerView: 2.5, spaceBetween: 10 },
                        485: { slidesPerView: 3.5, spaceBetween: 10 },
                        640: { slidesPerView: 3.5, spaceBetween: 20 },
                        1024: { slidesPerView: 4, spaceBetween: 30 },
                        1280: { slidesPerView: 4, spaceBetween: 40 },
                    }}
                >
                    {productdata?.map((val, index) => (
                        <SwiperSlide key={index}>
                            <Shop_by_papers_textures_cards val={val}/>
                        </SwiperSlide>
                    ))}
                </Swiper>
            </div>

        </section>
    )
}

export default YouMightIntrested
